document.addEventListener("DOMContentLoaded", ()=>{
  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGAnchorItem extends HTMLElement {
    static observer = null;
    static sectionToItem = new Map();
    static isScroll = false

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.sections = null;
      this._observedSection = null;
    }

    connectedCallback() {
      this.sections = document.querySelectorAll('#main .shopify-section');
      this.addEventListener('click', this.itemClick);

      const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
      if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

      const section = this.sections[sectionNumber - 1];
      if (!section) return;

      this._observedSection = section;
      YGAnchorItem._ensureObserver();
      YGAnchorItem.sectionToItem.set(section, this);
      YGAnchorItem.observer.observe(section);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);

      if (this._observedSection && YGAnchorItem.observer) {
        YGAnchorItem.sectionToItem.delete(this._observedSection);
        YGAnchorItem.observer.unobserve(this._observedSection);
      }
    }

    static _ensureObserver() {
      if (YGAnchorItem.observer) return;

      YGAnchorItem.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const item = YGAnchorItem.sectionToItem.get(entry.target);
            if (!YGAnchorItem.isScroll) {
              item && item._setActiveFromObserver();
            }
          });
        },
        {
          root: null,
          threshold: 0.01,
          rootMargin: '-20% 0px -70% 0px',
        }
      );
    }

    _setActiveFromObserver() {
      const parent = this.parentElement;
      if (!parent) return;

      parent.querySelectorAll('yg-anchor-item.yg-tab-item').forEach((el, index) => {
        el.classList.toggle('active', el === this);

        if(el === this) {
          this.labelClick(index)
        }
      });
    }

    labelClick(index) {
      // 添加新的活动状态
      const parent = this.parentElement;
      if (parent && this.isScrollable(parent)) {
        const containerRect = parent.getBoundingClientRect();
        const targetRect = this.getBoundingClientRect();
        const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 40;

        parent.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }

    isScrollable(el) {
      if (!el) return false;

      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;

      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

      return canScrollVertically || canScrollHorizontally;
    }

    itemClick() {
      const sectionNumber = this.getAttribute('data-section-number');
      YGAnchorItem.isScroll = true
      this._setActiveFromObserver()
      if (sectionNumber == 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        const section = this.sections[sectionNumber - 1];
        if (!section) return;
        const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }

      setTimeout(()=>{
        YGAnchorItem.isScroll = false
      },600)
    }
  }
  if (!window.customElements.get('yg-anchor-item')) {
    window.customElements.define('yg-anchor-item', YGAnchorItem);
  }
})

